"use client";
import { corners } from "@/lib/tokens/semantic";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <div style={{
      minHeight: "100dvh", background: "var(--cg-bg-elevated)", color: "var(--cg-text-primary)",
      padding: 24, fontFamily: "monospace", fontSize: 13,
      wordBreak: "break-all", whiteSpace: "pre-wrap",
    }}>
      <h2 style={{ color: "var(--cg-accent-danger)", margin: "0 0 16px" }}>Client Error</h2>
      <p><b>Message:</b> {error.message}</p>
      <p><b>Name:</b> {error.name}</p>
      {error.digest && <p><b>Digest:</b> {error.digest}</p>}
      <pre style={{
        background: "var(--cg-bg-sunken)", padding: 12, borderRadius: corners.input,
        overflow: "auto", fontSize: 11, marginTop: 12,
      }}>{error.stack}</pre>
    </div>
  );
}
